import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import {
  getCourseGroupInfo,
  getCourseHomeFilterInfo,
} from 'reduxModules/course/selector';
import {
  fetchCourseGradeLevels,
  fetchGroupCourseList,
} from 'reduxModules/course/action';
import useStyles from 'hooks/useStyles';
import { ChevronIcon } from 'components/Icon';
import Button from 'components/Button';

import useGetPathList from './useGetPathList';
import BreadcrumbSwitch from 'components/BreadcrumbSwitch';
import CourseList from '../components/CourseList';
import TagList from './components/TagList';

import styles from './CourseGroup.scss';

const getSelectedGradeLevelContent = (
  gradeLevelList,
  selectedGradeLevel,
  selectedSubject,
) => {
  if (gradeLevelList.length === 0) return [];
  if (selectedGradeLevel === 0) return [];

  const { subjects, ...gradeLevelInfo } = gradeLevelList.find(
    ({ id }) => id === selectedGradeLevel,
  );

  if (selectedSubject === 0) return [gradeLevelInfo];

  const { ...subjectInfo } = subjects.find(({ id }) => id === selectedSubject);

  return [gradeLevelInfo, subjectInfo];
};

export default function CourseGroup() {
  useStyles(styles);

  const { t } = useTranslation(['course']);
  const dispatch = useDispatch();
  const { id, hasMore, list, currentPage, title, description } = useSelector(
    getCourseGroupInfo,
  );
  const { selectedGradeLevel, selectedSubject, gradeLevels } = useSelector(
    getCourseHomeFilterInfo,
  );

  const pathList = useGetPathList();

  const handleClickMore = () => {
    dispatch(
      fetchGroupCourseList({
        groupId: id,
        currentPage: currentPage + 1,
      }),
    );
  };

  useEffect(() => {
    if (selectedGradeLevel !== 0 || selectedSubject !== 0) {
      dispatch(fetchCourseGradeLevels());
    }
  }, []);

  return (
    <div className={styles.root}>
      <BreadcrumbSwitch pathList={pathList} />
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.description}>{description}</div>
      <TagList
        list={getSelectedGradeLevelContent(
          gradeLevels,
          selectedGradeLevel,
          selectedSubject,
        )}
      />
      <div className={styles.courseList}>
        <CourseList groupId={id} groupTitle={title} courseList={list.flat()} />
      </div>
      <div className={styles.footer}>
        <Button reversed show={hasMore} onClick={handleClickMore}>
          <div>{t('home.courseIntro.courseCardMore')}</div>
          <ChevronIcon className={styles.moreDownIcon} />
        </Button>
      </div>
    </div>
  );
}
